import { AppConfig } from '@infl-ts/util-app-config';
import { keysWithMap, nullable } from '@infl-ts/util-io-ts';
import { PopoverConfig } from '@infl-ts/util-popover-config';
import * as t from 'io-ts';
export var AnalyticsConfig = t.type({
  googleAnalyticsTrackingId: nullable(t.string)
});
var FlowVariants = {
  BEFORE_SIGN_UP_AGREEMENT: 'BEFORE_SIGN_UP_AGREEMENT',
  BEFORE_SIGN_UP_CHECKBOX: 'BEFORE_SIGN_UP_CHECKBOX',
  AFTER_SIGN_UP_AGREEMENT: 'AFTER_SIGN_UP_AGREEMENT',
  AFTER_SIGN_UP_CHECKBOXES: 'AFTER_SIGN_UP_CHECKBOXES'
};
export var ConsentFlowVariant = keysWithMap(FlowVariants);
export var ConsentConfig = t.type({
  emailOptIn: nullable(t.string),
  flowVariant: ConsentFlowVariant,
  fields: t.array(t.type({
    id: t.string,
    label: t.string
  }))
});
export var ChallengeOnboarding = t.type({
  challengeID: t.string,
  skippable: t["boolean"]
});
export var WelcomeMessageOnboarding = t.type({
  message: t.string
});
export var Flow = t.union([WelcomeMessageOnboarding, ChallengeOnboarding]);
export var OnboardingConfig = t.type({
  flow: Flow
});
export var MultilingualConfig = t.type({
  enabled: t["boolean"],
  hubDefaultLang: t.string
});
export var ThemeConfig = t.type({
  bannerColorScheme: nullable(t.string),
  colorScheme: nullable(t.string),
  customFontUrl: nullable(t.string),
  customFontName: nullable(t.string)
});
export var Config = t.union([AppConfig, PopoverConfig, ThemeConfig, OnboardingConfig, ConsentConfig], 'Config');
export var Page = t.type({
  typename: t.literal('Page'),
  id: t.string,
  hash: t.string,
  href: t.string,
  display: t.string,
  favIcon: nullable(t.string),
  consentRequired: t["boolean"],
  blocks: t.readonly(t.UnknownArray)
});
export var SiteConfig = t.type({
  configs: t.type({
    AnalyticsConfig: nullable(AnalyticsConfig),
    AppConfig: nullable(AppConfig),
    ConsentConfig: nullable(ConsentConfig),
    OnboardingConfig: nullable(OnboardingConfig),
    PopoverConfig: nullable(PopoverConfig),
    ThemeConfig: nullable(ThemeConfig),
    MultilingualConfig: nullable(MultilingualConfig)
  }),
  pages: t.array(Page)
});